module.exports = __webpack_public_path__ + "static/media/logo.853d0055.png";